import useAsyncData from "../../../../hooks/use-async-data";
import mileageService from "../../mileage.service";
import MileageAddressListItem from "./mileage-address-list";
import MileageAddressListParams from "./mileage-address-list-params";

const useMileageAddressList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<MileageAddressListItem[]>([]);

  const load = async (
    params: MileageAddressListParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await mileageService.getAddressList(params, abortSignal);

      setData(data);
      setIsLoading(false);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMileageAddressList;
